import { useMutation } from '@tanstack/react-query';

import { engagementResourcesService } from '../services';
import type { RequestResourceUploadUrlInput } from '../types';

/**
 * Step 1 of the resource upload flow — request a presigned S3 PUT URL.
 *
 * The BE persists the derived S3 key onto the resource row in the same
 * transaction before returning, so callers do NOT need to PATCH the key
 * afterwards. After the direct `PUT` to `uploadUrl` succeeds, the caller
 * should invalidate the resource detail query to pick up the fresh
 * `contentDownloadUrl` / `thumbnailDownloadUrl`.
 */
export function useRequestResourceUploadUrl() {
  return useMutation({
    mutationFn: (input: RequestResourceUploadUrlInput) =>
      engagementResourcesService.requestUploadUrl(input),
  });
}
